<template>
  <h1>...</h1>
</template>

<script src="./oauth_callback.js"></script>
